// App.js
import React from 'react';
import { Provider } from 'react-redux';
import { useRoutes } from 'react-router-dom';
import { MatxTheme } from './components';
import { AuthProvider } from './contexts/JWTAuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { Store } from './redux/Store';
import routes from './routes';
import { NotificationsProvider } from './contexts/NotificationContext'; // Import NotificationsProvider
import { SnackbarProvider } from './contexts/SnackBarContext';
import { ConfirmationProvider } from './contexts/ConfirmationContext';

const App = () => {
  const content = useRoutes(routes);

  return (
    <Provider store={Store}>
      <SettingsProvider>
        <MatxTheme>
          <AuthProvider>
            <ConfirmationProvider>
              <SnackbarProvider>
                <NotificationsProvider> {/* Wrap with NotificationsProvider */}
                  {content}
                </NotificationsProvider>
              </SnackbarProvider>
            </ConfirmationProvider>
          </AuthProvider>
        </MatxTheme>
      </SettingsProvider>
    </Provider>
  );
};

export default App;
